//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  events,
  RunConfigService,
  // util,
  SitesSessionStorageService,
  SitesLocalStorageService
} from "@nuskin/ns-util";
import { NsIcon } from "@nuskin/design-components";

import { isString } from "@nuskin/ns-common-lib";

const AUTO_REDIRECT_KEY = "autoRedirectGlobalLanding";
const CURRENT_PAGE_KEY = "currentPage";
const HREF_OVERRIDE_KEY = "hrefOverride";

const defaultTranslations = {
  selectOther: "Select Other"
};

export default {
  name: "NsMinimalHeaderRegionSelector",
  components: { NsIcon },
  props: {
    /**
     * If set, this will override the page redirect on the region selector page
     */
    hrefOverride: {
      type: String,
      default: ""
    },
    /**
     * Sets other available regions in the region selector dropdown
     */
    region: {
      type: Object,
      default: function() {
        return {};
      }
    },
    /**
     * Allows you to set where the "select other region" redirects too
     */
    regionSelectorPath: {
      type: String,
      default: "/content/nuskin.html#region-selection"
    },
    /**
     * Translations
     */
    translations: {
      type: Object,
      default: () => defaultTranslations
    }
  },
  data() {
    return {
      languageCode: "",
      language: "",
      countryCode: "",
      otherLanguages: [],
      dropdownOpen: false
    };
  },
  watch: {
    region: {
      immediate: true,
      handler(value) {
        this.setRegionData(value);
      }
    }
  },
  methods: {
    /**
     * Returns the browser's url with the language replaced by the new one.
     */
    getHrefForLanguage(languageCode, countryCode) {
      const runConfig = RunConfigService.getRunConfig();
      const url = window.location.href;
      const locale = `${runConfig.language}_${runConfig.country}`;
      return url.replace(locale, `${languageCode}_${countryCode}`);
    },
    /**
     * Convert the provided region prop into usable data for the template
     */
    setRegionData(region) {
      const {
        languageCodes, // ["en", "vi", "es", "zh"] - (ordered)
        languages, // ["English", "Tieng Viet", "Espanol", ...] - (ordered)
        locale_names, // [{ en: "United States" }, { es: "Estados Unidos" }, ...]
        countryCode // "US"
        // paths // [{ vi: "/content/nuskin/vi_US" }, { es: "/content/nuskin/es_US" }, ...]
      } = region;

      if (languageCodes && languages && locale_names && countryCode) {
        const regions = languageCodes.map((languageCode, index) => ({
          languageCode,
          language: languages[index]
          // path:
          //   (paths.find(item => item[languageCode]) || {})[languageCode] || ""
        }));
        const currentLanguageCode = RunConfigService.getRunConfig().language;
        const currentRegion =
          regions.find(region => region.languageCode === currentLanguageCode) ||
          {};

        // set region data
        this.languageCode = currentRegion.languageCode || "";
        this.language = currentRegion.language || "";
        this.countryCode = countryCode;
        this.otherLanguages = regions.map(region => ({
          languageCode: region.languageCode,
          language: region.language,
          href: this.getHrefForLanguage(region.languageCode, countryCode)
        }));
      } else {
        // clear region data
        this.languageCode = "";
        this.language = "";
        this.countryCode = "";
        this.otherLanguages = [];
      }
    },
    /**
     * Close the dropdown
     */
    close() {
      this.dropdownOpen = false;
    },
    /**
     * Save global variables to session storage before navigating away
     */
    selectOtherRegion() {
      if (this.hrefOverride) {
        SitesSessionStorageService.writeItem(
          HREF_OVERRIDE_KEY,
          isString(this.hrefOverride)
            ? this.hrefOverride
            : JSON.stringify(this.hrefOverride)
        );
      }

      SitesLocalStorageService.writeItem(
        CURRENT_PAGE_KEY,
        window.location.href
      );

      SitesLocalStorageService.removeItem(AUTO_REDIRECT_KEY);

      window.location = this.regionSelectorPath;
    },
    selectLanguage(code, href) {
      const runConfig = RunConfigService.getRunConfig();
      events.publish(
        events.header.LANGUAGE_CHANGED || "headerLanguageChanged",
        {
          oldLanguage: runConfig.language,
          country: runConfig.country,
          language: code
        }
      );
      //Only redirect if the href is different than the current page and we aren't the catalog app
      if (
        window.location.href !== href &&
        href.indexOf("/static/catalog/") === -1
      ) {
        window.location = href;
      }
    },
    toggleRegionDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    }
  }
};
